/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Submit_DescriptionInputs */

const en_seo_submit_description = /** @type {(inputs: Seo_Submit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a new AI tool, AIGC product, or service for review.`)
};

const zh_seo_submit_description = /** @type {(inputs: Seo_Submit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交新的 AI 工具、AIGC 产品或服务，等待审核。`)
};

/**
* | output |
* | --- |
* | "Submit a new AI tool, AIGC product, or service for review." |
*
* @param {Seo_Submit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_submit_description = /** @type {((inputs?: Seo_Submit_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Submit_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_submit_description(inputs)
	return zh_seo_submit_description(inputs)
});
export { seo_submit_description as "seo.submit.description" }